import NavMenu from "../components/NavMenu";

export default function UsuarioHome() {
  return (
    <>
      <div className="home">
        <h1>Bienvenido Usuario</h1>
        <p>Esta es tu área de usuario.</p>
      </div>
    </>
  );
}
